import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "token-collapse-group flex align-items-center gutter-s1" }

import { TokenInfo } from '@/sdk/entities/portfolio';
import TokenCollapse from '@/components/token/TokenCollapse.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenCollapseGroup',
  props: {
    tokens: null
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'click', value: Record<string, unknown>): void;
}), expose: any, slots: any, attrs: any }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tokens, (token) => {
      return (_openBlock(), _createElementBlock("div", {
        key: token.tokenAddress,
        class: "flex-center"
      }, [
        _createVNode(TokenCollapse, {
          token: token.token,
          onClick: ($event: any) => (emits('click', token))
        }, null, 8, ["token", "onClick"])
      ]))
    }), 128))
  ]))
}
}

})